export default __webpack_public_path__ + "static/media/banner.6a58c6bf.png";